import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-center break-words bg-shade-white" }

import { computed, defineAsyncComponent } from 'vue'
import { useAuthStore } from '@shared/stores/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutToken',
  setup(__props) {

const BodyText = defineAsyncComponent(() => import('@shared/design-system/components/Typography/BodyText.vue'))

const authStore = useAuthStore()

const authStoreFormatted = computed<{ key: string, value: unknown }[]>(() => {
  return Object.entries(authStore).map(([key, value]) => {
    if (typeof value !== 'function' && !key.startsWith('$') && !key.startsWith('_')) {
      return { key, value }
    }
  }).filter(entry => entry !== undefined).sort((key1, key2) => {
      if (key2 < key1) {
        return -1
      }
      if (key2 > key1) {
        return 1
      }
      return 0
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(authStoreFormatted.value, ({ key, value }) => {
      return (_openBlock(), _createElementBlock("div", {
        key: key,
        class: "text-pretty w-3/5 flex flex-col p-4"
      }, [
        _createVNode(_unref(BodyText), {
          size: "large",
          class: "font-bold"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(key) + ": ", 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1024 /* DYNAMIC_SLOTS */),
        _createVNode(_unref(BodyText), null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(value), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1024 /* DYNAMIC_SLOTS */)
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})